import styled from 'styled-components';

const Label = styled.span`
  font-family: 'Open Sans', sans-serif;
  font-size: ${(props) => `${14 + (props.fontSizeSetting || 0)}px !important`};
  margin-left: 6px;
  font-weight: ${(props) => props.fontWeight || 600};
  text-align: ${(props) => props.textAlign || 'left'};
  word-break: ${(props) => props.wordBreak || 'break-word'};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  color: ${(props) => (props.disabled ? '#b9b9b9' : props.borderColor || '#3B3F51')};

  @media (max-width: 1366px) {
    width: fit-content;
  }
`;

export default Label;
